import { every, isEmpty } from "@s-libs/micro-dash";

import {
  userEmailText,
  userNameTextCss,
  userPopoutContainerCss,
} from "@/base/NewselaGlobalLayoutV2/NavigationBar/UserProfileMenu/UserProfilePopout/PopoutUserInformation/PopoutUserInformation.styles";
import getUserProperties from "@/users/getUserProperties";
import useUser from "@/users/useUser";
import { getLicensesLists } from "../PopoutSubscriptions/PopoutSubscriptions.utils";

const PopoutUserInformation = () => {
  const { data: user } = useUser();
  const { hasAccessToLite, hasNceTrialCampaign, isImpersonated } =
    getUserProperties(user, { shouldUseNewUserApi: false });
  const licensesList = getLicensesLists(
    hasNceTrialCampaign,
    user?.licenses || [],
  );

  return (
    <div
      css={userPopoutContainerCss(
        hasAccessToLite && every(licensesList, isEmpty),
        isImpersonated,
      )}
    >
      <div css={userNameTextCss} data-qa-selector="global-nav-user-name">
        {isImpersonated ? "Impersonating: " : ""}
        {user.name}
      </div>
      <div css={userEmailText} data-qa-selector="global-nav-user-email">
        {user.email}
      </div>
    </div>
  );
};

PopoutUserInformation.displayName = "PopoutUserInformation";
export { PopoutUserInformation };
